import {Component, OnInit} from '@angular/core';
import {ExamesCargosService} from "./exames-cargos.service";
import {ExamesCargosModel} from "./exames-cargos.model";
import {Global} from "../../global";
import {Components} from "../../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../../funcoes";
import {LoginService} from "../../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-exames-cargos',
  templateUrl: './exames-cargos.component.html'
})
export class ExamesCargosComponent extends Components implements OnInit {

  cargos: ExamesCargosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private examesCargosService: ExamesCargosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao && data.privilegios[i].acao[0] && (data.privilegios[i].acao[0].url == 'exames' || data.privilegios[i].id_acao == '33')){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregarCargos();
  }

  carregarCargos() {
    this.carregandoTabela = true;
    this.examesCargosService.get(null, null, null, {ordem: "A", nome_pt: "A"})
      .subscribe(data => {
        let payload = data['Payload'];
        this.cargos = Array.isArray(payload) ? payload : (payload && payload.data ? payload.data : []);
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.cargos);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(cargo) {
    let cargos = this.cargos;
    let examesCargosService = this.examesCargosService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCargo') + ': ' + cargo.nome_pt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      () => {
        if(this.global.debug == true){
          console.log(cargos);
        }

        let index = cargos.indexOf(cargo);
        cargos.splice(index, 1);

        examesCargosService.apagar(cargo.id)
          .subscribe(res => {
              this.cargos = cargos;
              this.ordenouCargos(null);
            },
            err => {
              cargos.splice(index, 0, cargo);
              this.cargos = cargos;
              this.func.showErro(err.json());
            });
      });
  }

  ordenouCargos(e) {
    for (let i = 0; i < this.cargos.length; i++) {
      this.cargos[i].ordem = i + 1;
    }
    this.examesCargosService.ordenaCargos(this.cargos)
      .subscribe(
        json => {},
        error => {
          this.func.showErro(error.json());
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/cargos/exames-cargos.component.ts